import GithubSlugger from "github-slugger"

/**
 * Heading-id helpers built on GithubSlugger so docs anchors match the ids
 * GitHub-style tooling (and the internal-link tests) would produce.
 */

/** A fresh slugger; call `.slug()` in document order for de-duplicated ids. */
export const createSlugger = (): GithubSlugger => new GithubSlugger()

/** Slug for a single string, with no de-duplication history. */
export const slugify = (text: string): string => new GithubSlugger().slug(text)

/** Slug a list of headings in order, de-duplicating like a rendered page. */
export const slugifyHeadings = (texts: string[]): string[] => {
  const slugger = new GithubSlugger()
  return texts.map((text) => slugger.slug(cleanHeadingText(text)))
}

/**
 * Reduce a heading's markdown *source* to its rendered text before slugging,
 * so slugs computed from source (search index, link tests) match the ids the
 * renderer derives from the mdast text. GithubSlugger already drops most
 * punctuation identically; links/images are the case that diverges.
 */
export const cleanHeadingText = (text: string): string =>
  text
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
